import { setTitle } from "../helpers";
import "../styles/not-found.css";

export const NotFound = () => {
  setTitle("Not found");

  return (

    <div id="not-found-page">
      <div>🤷🏻‍♂️ 404</div>
      <a href="javascript:history.back()">🔙</a>
    </div>
  );
};
